import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as calendarioActions from '../../reducers/CalendarioReducer/actions'
import { calendarioPickupSelector, calendarioDeliverySelector } from '../../selectors/calendarioSelector'
import { usuarioSelector, instalacionSelector } from '../../selectors/sessionSelector'
import { sucursalesSelector } from '../../selectors/sucursalesSelector'
import Calendario from '../../components/Calendario'
import PropTypes from 'prop-types';
import { getDomicilioLocalidadPreferenciaEntregaCliente } from '../../sagas/LocalidadEntregaSaga/calls'
class CalendarioContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sucursalesPickup: [],
      sucursalPickupSeleccionada: undefined,
      localidadDeliverySeleccionada: undefined,
      loadingLocalidad: true
    };
  }

async componentDidMount() {
    if (this.props.sucursales && this.props.sucursales.length > 0) {
      this.initializeSucursalesPickup();
    }

    await this.obtenerLocalidadPreferenciaCliente();
  }

obtenerLocalidadPreferenciaCliente = async () => {
  try {
    const { usuario, localidadesEntregaActivas } = this.props;
    
    if (usuario && usuario.idCliente) {
      const response = await getDomicilioLocalidadPreferenciaEntregaCliente(usuario.idCliente);
      
      let localidadId = null;
      
      if (response && response.idLocalidadEntrega) {
        localidadId = response.idLocalidadEntrega;
      } else if (localidadesEntregaActivas && localidadesEntregaActivas.length > 0) {
        localidadId = localidadesEntregaActivas[0].idLocalidadEntrega;
      }
      this.setState({
        localidadDeliverySeleccionada: localidadId,
        loadingLocalidad: false
      }, () => {
        if (localidadId !== null) {
          this.getCalendario(2, localidadId);
        }
        else{
          this.getCalendario(2);
        }
      });
    } else {
      // Caso sin usuario
      this.setState({ 
        loadingLocalidad: false 
      });
    }
  } catch (error) {
    console.error("Error obteniendo localidad preferencia:", error);
    this.setState({ 
      loadingLocalidad: false 
    });
  }
};

  componentDidUpdate(prevProps) {
    // Inicializa solo cuando llegan sucursales y todavía no están en state
    if (
      this.state.sucursalesPickup.length === 0 &&
      this.props.sucursales &&
      this.props.sucursales.length > 0
    ) {
      this.initializeSucursalesPickup();
    }
  }

  initializeSucursalesPickup() {
    const { sucursales, usuario } = this.props;
    const sucursalesPickup = sucursales
      .filter(sucursal => sucursal.formasDeEntrega.find(x => x.idFormaEntrega === 1))
      .map(sucursal => ({
        idSucursal: sucursal.idSucursal,
        nombre: sucursal.nombre,
        direccion: sucursal.direccion,
        porDefecto: sucursal.formasDeEntrega.find(x => x.idFormaEntrega === 1).porDefecto
      }));

    const sucursalPickupSeleccionada =
      this.state.sucursalPickupSeleccionada !== undefined &&
      this.state.sucursalPickupSeleccionada !== null &&
      this.state.sucursalPickupSeleccionada !== '' &&
      sucursalesPickup.some((x) => String(x.idSucursal) === String(this.state.sucursalPickupSeleccionada))
        ? this.state.sucursalPickupSeleccionada
        : undefined;

    this.setState({
      sucursalesPickup,
      sucursalPickupSeleccionada
    });
  }

  getCalendario = (idTipoCalendario, idLocalidadParam=null) => {
    const { instalacion, usuario, sagaFetchCalendario } = this.props;
    // console.log('props getCalendario', this.props);
// Obtener sucursales de diferentes fuentes
    const sucursalesFromState = this.state.sucursalesPickup;
    const sucursalesFromProps = this.props.sucursales;
    
    // Usar las del state si existen, sino las del props
    const sucursales = sucursalesFromState.length > 0 ? sucursalesFromState : sucursalesFromProps;
    
    // Buscar la sucursal con el menor idSucursal como por defecto
    const sucursalPorDefecto = sucursales.length > 0 
      ? sucursales.reduce((prev, current) => 
          (prev.idSucursal < current.idSucursal) ? prev : current
        )
      : null;

    // Siempre tener un fallback - usar la sucursal con el primer idSucursal para pedidos deliver, porque pickup selecciona la sucursal
    const idSucursalDefecto = sucursalPorDefecto ? sucursalPorDefecto.idSucursal : null;
  const idClienteUsuario = usuario && usuario.idCliente ? usuario.idCliente : null;
    let id;

    switch (idTipoCalendario) {
      case 1:
        // id_anterior = usuario.ultimaSucursalPickup || (sucursales.find(x => x.porDefecto === true) || {}).idSucursal;
        // console.log('id_anterior:', usuario.ultimaSucursalPickup || (sucursales.find(x => x.porDefecto === true) || {}).idSucursal;);
        id = usuario.ultimaSucursalPickup || idSucursalDefecto;

        break;

      case 2:
        // id = usuario.ultimaSucursalDelivery || (sucursales.find(x => x.porDefecto === true) || {}).idSucursal;
        id = usuario.ultimaSucursalDelivery || idSucursalDefecto;
        break;

      default:
        break;
    }
    // console.log('== DEBUG getCalendario ==');
    // console.log('idTipoCalendario:', idTipoCalendario);
    // console.log('usuario.ultimaSucursalPickup:', usuario.ultimaSucursalPickup);
    // console.log('usuario.ultimaSucursalDelivery:', usuario.ultimaSucursalDelivery);
    // console.log('sucursales:', sucursales);
    // console.log('instalacion.id:', instalacion && instalacion.id);
    // console.log('idSucursalDefecto:', idSucursalDefecto);
    // console.log('id seteado (sucursal):', id);

    const payload = {
      idTipoCalendario,
      idInstalacion: id || instalacion.id,
      idRecurso: id || 1,
      idCliente: idClienteUsuario
    };
    if (idTipoCalendario === 2 && idLocalidadParam !== null && idLocalidadParam !== undefined) {
      payload.idLocalidadEspecifica = idLocalidadParam;
    }
    sagaFetchCalendario(payload);
  };

  handleOnChangeSucursalPickup = (idSucursal) => {
    if (idSucursal === undefined || idSucursal === null || idSucursal === '') {
      return;
    }

    const idSucursalNumber = Number(idSucursal);
    const sucursalNormalizada = Number.isNaN(idSucursalNumber) ? idSucursal : idSucursalNumber;

    this.setState({ sucursalPickupSeleccionada: sucursalNormalizada });
    const payload = {
      idTipoCalendario: 1,
      idInstalacion: sucursalNormalizada,
      idRecurso: sucursalNormalizada || 1
    };

    this.props.sagaFetchCalendario(payload);
  };
  
  handleOnChangeLocalidadDelivery = (idLocalidad) => {
    this.setState({
            localidadDeliverySeleccionada: idLocalidad,
          });
    this.getCalendario(2, idLocalidad);
  };

  render() {
    return (
      <Calendario
        calendarioPickup={this.props.calendarioPickup}
        calendarioDelivery={this.props.calendarioDelivery}
        handleOnClose={this.props.handleOnClose}
        sucursalesPickup={this.state.sucursalesPickup}
        sucursalPickupSeleccionada={this.state.sucursalPickupSeleccionada}
        handleOnChangeSucursalPickup={(e) => this.handleOnChangeSucursalPickup(e.target.value)}
        localidadesEntregaActivas={this.props.localidadesEntregaActivas}
        handleOnChangeLocalidadDelivery={(e) => this.handleOnChangeLocalidadDelivery(e.target.value)}
        localidadDeliverySeleccionada={this.state.localidadDeliverySeleccionada}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...calendarioActions,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    instalacion: instalacionSelector(state),
    calendarioPickup: calendarioPickupSelector(state),
    calendarioDelivery: calendarioDeliverySelector(state),
    usuario: usuarioSelector(state),
    sucursales: sucursalesSelector(state)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarioContainer);
